export const isURL = (url) => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

export const baseQuickActionsCompany = [
  'ASSESSMENT',
  'OBSERVATION',
  'LOG_TIME',
  'MEETING',
  'ACTION',
  'INCIDENT',
  'DAILY_LOG',
];
